import { NgModule } from '@angular/core';
import {
  ArrayFirstCustomPipe,
  ArrMapCustomPipe,
  ArrToStrCustomPipe,
  CleanArrayCustomPipe,
  ConsoleLogCustomPipe,
  EvaluateCustomPipe,
  FormatDateCustomPipe,
  FormatDateTimeCustomPipe,
  FormatTimeCustomPipe,
  FunctionCustomPipe,
  GetProfilePicCustomPipe,
  InvalidControlCustomPipe,
  InvokerCustomPipe,
  JoinArrCustomPipe,
  JoinCustomPipe,
  JoinPathCustomPipe,
  MethodCustomPipe,
  NumberAmountToWordsCustomPipe,
  NumberPlacementCustomPipe,
  ObjToArrCustomPipe,
  PadEndCustomPipe,
  PadStartCustomPipe,
  PrintBillEmployeeCustomPipe,
  ReplaceCustomPipe,
  RoundoffCustomPipe,
  SplitCustomPipe,
  StringifyCustomPipe,
  StrLimitCustomPipe,
  SumCustomPipe,
  ToFixedCustomPipe,
  ToNumberCustomPipe,
  ToStrCustomPipe,
  UppcaseOnCustomPipe,
  ValueAtCustomPipe,
  IsAllCustomPipe
} from '../../custom-pipes/custom-pipes.pipe';



@NgModule({
  declarations: [
    ReplaceCustomPipe,
    FormatDateCustomPipe,
    FormatTimeCustomPipe,
    FormatDateTimeCustomPipe,
    MethodCustomPipe,
    FunctionCustomPipe,
    StringifyCustomPipe,
    RoundoffCustomPipe,
    EvaluateCustomPipe,
    PadStartCustomPipe,
    PadEndCustomPipe,
    ArrToStrCustomPipe,
    ArrMapCustomPipe,
    StrLimitCustomPipe,
    ObjToArrCustomPipe,
    ConsoleLogCustomPipe,
    UppcaseOnCustomPipe,
    NumberPlacementCustomPipe,
    InvalidControlCustomPipe,
    ArrayFirstCustomPipe,
    JoinPathCustomPipe,
    ToStrCustomPipe,
    ToFixedCustomPipe,
    PrintBillEmployeeCustomPipe,
    JoinCustomPipe,
    GetProfilePicCustomPipe,
    InvokerCustomPipe,
    SplitCustomPipe,
    ValueAtCustomPipe,
    JoinArrCustomPipe,
    SumCustomPipe,
    NumberAmountToWordsCustomPipe,
    CleanArrayCustomPipe,
    ToNumberCustomPipe,
    IsAllCustomPipe,
  ],
  exports: [
    ReplaceCustomPipe,
    FormatDateCustomPipe,
    FormatTimeCustomPipe,
    FormatDateTimeCustomPipe,
    MethodCustomPipe,
    FunctionCustomPipe,
    StringifyCustomPipe,
    RoundoffCustomPipe,
    EvaluateCustomPipe,
    PadStartCustomPipe,
    PadEndCustomPipe,
    ArrToStrCustomPipe,
    ArrMapCustomPipe,
    StrLimitCustomPipe,
    ObjToArrCustomPipe,
    ConsoleLogCustomPipe,
    UppcaseOnCustomPipe,
    NumberPlacementCustomPipe,
    InvalidControlCustomPipe,
    ArrayFirstCustomPipe,
    JoinPathCustomPipe,
    ToStrCustomPipe,
    ToFixedCustomPipe,
    PrintBillEmployeeCustomPipe,
    JoinCustomPipe,
    GetProfilePicCustomPipe,
    InvokerCustomPipe,
    SplitCustomPipe,
    ValueAtCustomPipe,
    JoinArrCustomPipe,
    SumCustomPipe,
    NumberAmountToWordsCustomPipe,
    CleanArrayCustomPipe,
    ToNumberCustomPipe,
    IsAllCustomPipe,
  ],
  imports: []
})
export class AccCustomPipeModule { }
